/**
 * iPIDiagram Application Configuration
 */

import type { ChartImage, DropdownOption, LivePlotImageOptions, LivePlotSizeOptions, PlotSpec, PrintChartAspect, RichSummary } from '../shared';

export const APP_NAME = 'iPIDiagram';
export const APP_VERSION = '1.1.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

// Load type options
export const LOAD_TYPES: DropdownOption[] = [
  { value: '0', label: 'Triangular Load' },
  { value: '1', label: 'Triangular Pulse Load' },
  { value: '2', label: 'Rectangular Load' }
];

/**
 * API Payload Type
 */
export interface APIPayload {
  title: string;
  length: string;
  tribWidth: string;
  hingeLength: string;
  totalWeight: string;
  klmFactor: string;
  Ru: string;
  Xe: string;
  loadType: string;
  Pa: string;
  Ia: string;
  ductilityLimit: string;
  rotationLimit: string;
}

export type ChartKey = 'chart_pi';

export const PRINT_CHART_ORDER: ChartKey[] = ['chart_pi'];

export const PRINT_CHART_ASPECT = {
  chart_pi: 'square'
} satisfies Record<ChartKey, PrintChartAspect>;

export const LIVE_PLOT_CARD_MIN_HEIGHT = 'clamp(20rem, 72vw, 34rem)';

export const LIVE_PLOT_SIZE_BY_KEY = {
  chart_pi: {
    fit: 'width',
    width: '100%',
    maxWidth: '44rem',
    aspectRatio: '1 / 1'
  }
} satisfies Record<ChartKey, LivePlotSizeOptions>;

export const PRINT_CHART_IMAGE_OPTIONS: Record<ChartKey, LivePlotImageOptions> = {
  chart_pi: {
    width: 700,
    height: 700,
    scale: 2,
    layout: {
      font: { size: 16 },
      title: { font: { size: 24 } },
      margin: { l: 92, r: 32, t: 82, b: 112 },
      xaxis: { title: { font: { size: 18 } }, tickfont: { size: 14 } },
      yaxis: { title: { font: { size: 18 } }, tickfont: { size: 14 } },
      legend: { font: { size: 14 }, x: 0.5, xanchor: 'center', y: -0.28 }
    }
  }
};

export interface APIResponse {
  summary: RichSummary;
  plotData: Partial<Record<ChartKey, PlotSpec>>;
}

// Frontend state for this page after analysis. The API returns summary + plotData only;
// `charts` is generated later from mounted LivePlot components for print/save.
export type PIDiagramResultState = APIResponse & {
  charts?: Partial<Record<ChartKey, ChartImage>>;
};
